<template>
  <div class="period-plan-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PeriodPlanGroup',
};
</script>
